<template>
  <div id="SynthesisView" class="view" :style="minHeight">
    <page-intro 
      :sub-title="gpsst.resultSubTitle" 
      :view="'synthesis'"
      v-on:changeview="$emit('changeview',$event)"
    ></page-intro>
    <div v-if="resultChapo_g" class="editorial" v-html="resultChapo_g"></div>
   
    <generate-pdf></generate-pdf>
    <synthesis v-on:changeview="$emit('changeview',$event)"></synthesis>

    <page-menu
      :view="'synthesis'"
      v-on:changeview="$emit('changeview',$event)"
    ></page-menu>
  </div>
</template>

<script>
import PageIntro from "../components/PageIntro";
import PageMenu from "../components/PageMenu";
import Synthesis from "../components/synthesis/Synthesis";
import GeneratePdf from "../components/synthesis/GeneratePdf";

export default {
  name: "SynthesisView",
  components: {
    PageIntro,
    PageMenu,
    Synthesis,
    GeneratePdf
  },
  props: {
    minHeight: String
  },
  computed: {
    gpsst: function() {
      return this.$store.state.gpsstModule.gpsst;
    },
    resultChapo_g: function() {
      return JsonDataModule.getValueWithGlossary(this.gpsst, 'resultChapo'); //eslint-disable-line no-undef
    }    
  },
  mounted: function() {
    initTooltips("#SynthesisView"); //eslint-disable-line no-undef
  },
  updated: function() {
    initTooltips("#SynthesisView"); //eslint-disable-line no-undef
  }
};
</script>